/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffMessagePage } from './StaffMessagePage';
import {
    StaffMessagePageFromJSON,
    StaffMessagePageFromJSONTyped,
    StaffMessagePageToJSON,
    StaffMessagePageToJSONTyped,
} from './StaffMessagePage';

/**
 * 
 * @export
 * @interface StaffMessagePageResponse
 */
export interface StaffMessagePageResponse {
    /**
     * 
     */
    data: StaffMessagePage;
}

/**
 * Check if a given object implements the StaffMessagePageResponse interface.
 */
export function instanceOfStaffMessagePageResponse(value: object): value is StaffMessagePageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffMessagePageResponseFromJSON(json: any): StaffMessagePageResponse {
    return StaffMessagePageResponseFromJSONTyped(json, false);
}

export function StaffMessagePageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffMessagePageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffMessagePageFromJSON(json['data']),
    };
}

export function StaffMessagePageResponseToJSON(json: any): StaffMessagePageResponse {
    return StaffMessagePageResponseToJSONTyped(json, false);
}

export function StaffMessagePageResponseToJSONTyped(value?: StaffMessagePageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffMessagePageToJSON(value['data']),
    };
}

